import Button from 'Components/UI/Button';
import { withStyles } from '@material-ui/core/styles';

const RoundButton = withStyles(theme => ({
  root: {
    borderRadius: theme.radius.lg,
  },
}))(Button);

export default RoundButton;
